import { render, staticRenderFns } from "./movementRecord.vue?vue&type=template&id=8019a5fe&"
import script from "./movementRecord.vue?vue&type=script&lang=js&"
export * from "./movementRecord.vue?vue&type=script&lang=js&"
import style0 from "./movementRecord.vue?vue&type=style&index=0&id=8019a5fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports